import { Alert, Button, Snackbar } from "@mui/material";
import { describeCellValue, formatChangedAgo } from "./pipelineCellSave";
import type { PipelineConflictNotice as ConflictNotice } from "./usePipelineCellSave";

type PipelineConflictNoticeProps = {
  conflict: ConflictNotice | null;
  onApplyMine: () => void;
  onDismiss: () => void;
};

/** Shown when a cell save lost to someone else's newer change. */
export function PipelineConflictNotice({
  conflict,
  onApplyMine,
  onDismiss,
}: PipelineConflictNoticeProps) {
  return (
    <Snackbar
      open={conflict != null}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      onClose={(_event, reason) => {
        if (reason !== "clickaway") onDismiss();
      }}
    >
      <Alert
        severity="warning"
        variant="filled"
        onClose={onDismiss}
        action={
          <>
            <Button color="inherit" size="small" onClick={onApplyMine}>
              Use mine
            </Button>
            <Button color="inherit" size="small" onClick={onDismiss}>
              Keep theirs
            </Button>
          </>
        }
      >
        {conflict && (
          <>
            {conflict.changedBy ?? "Someone else"} changed{" "}
            <strong>{conflict.fieldLabel}</strong> on {conflict.dealName} to{" "}
            <strong>{describeCellValue(conflict.theirs)}</strong>
            {formatChangedAgo(conflict.changedAt)}. Your value (
            {describeCellValue(conflict.mine)}) was not saved.
          </>
        )}
      </Alert>
    </Snackbar>
  );
}
